export class PoGrnData{
    poQty:number[];
    grnQty:number[];
}